


















import Vue from 'vue'
import ModalFullScreen from '@/common/components/ModalFullScreen.vue'
import BrandsList from '@/common/components/BrandsList.vue'
import CategoriesList from '@/common/components/CategoriesList.vue'
import { ProductCategory } from '@/model/productCategory'
import { BrandModel } from '@/common/types/brands'

export enum FullScreenModalTypes {
  CATEGORIES = 'categories',
  BRANDS = 'brands'
}

export default Vue.extend({
  components: {
    ModalFullScreen,
    CategoriesList,
    BrandsList
  },
  props: {
    currentModalType: {
      type: String as () => FullScreenModalTypes,
      required: true
    },
    categories: {
      type: Array as () => ProductCategory[],
      default: () => []
    },
    brands: {
      type: Array as () => BrandModel[],
      default: () => []
    }
  },
  computed: {
    FullScreenModalTypes(): typeof FullScreenModalTypes {
      return FullScreenModalTypes
    },
    modalTitle(): string {
      switch (this.currentModalType) {
        case FullScreenModalTypes.CATEGORIES:
          return 'カテゴリから探す'
        case FullScreenModalTypes.BRANDS:
          return 'ブランドから探す'
        default:
          return ''
      }
    }
  }
})
